/* eslint-disable */
import Long from "long";
import _m0 from "protobufjs/minimal";
import {
  ExposureMode_Enum,
  exposureMode_EnumFromJSON,
  exposureMode_EnumToJSON,
} from "../../../../gen/user_camera/exposure_mode";
import { CameraSettings, PhotoFormat, PhotoSettings, PhotoType } from "../../mission_camera_settings";

export const protobufPackage = "skills";

/** Arguments for toggling photo interval mode. */
export interface TogglePhotoIntervalModeActionArgs {
  /** Enables photo interval mode if true, disables it if false */
  enable: boolean;
  /** If used, take photo every range_interval meters traveled by the vehicle */
  useRangeInterval: boolean;
  rangeInterval: number;
  /** If used, take photo every time_interval seconds */
  useTimeInterval: boolean;
  /** Time interval for taking photos in seconds. Range: 1-10. */
  timeInterval: number;
  /** General camera settings like exposure time, iso, etc. */
  cameraSettings:
    | CameraSettings
    | undefined;
  /** Photo specific settings */
  photoSettings:
    | PhotoSettings
    | undefined;
  /** DEPRECATED use photo_settings field */
  photoType:
    | PhotoType
    | undefined;
  /** DEPRECATED use photo_settings field */
  photoFormat:
    | PhotoFormat
    | undefined;
  /** DEPRECATED use photo_settings field */
  photoQuality: number;
  /** DEPRECATED use camera_settings field */
  exposureMode: ExposureMode_Enum;
}

export interface TogglePhotoIntervalModeResultData {
}

export interface TogglePhotoIntervalModeActionStateData {
}

function createBaseTogglePhotoIntervalModeActionArgs(): TogglePhotoIntervalModeActionArgs {
  return {
    enable: false,
    useRangeInterval: false,
    rangeInterval: 0,
    useTimeInterval: false,
    timeInterval: 0,
    cameraSettings: undefined,
    photoSettings: undefined,
    photoType: undefined,
    photoFormat: undefined,
    photoQuality: 0,
    exposureMode: 0,
  };
}

export const TogglePhotoIntervalModeActionArgs = {
  encode(message: TogglePhotoIntervalModeActionArgs, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.enable === true) {
      writer.uint32(8).bool(message.enable);
    }
    if (message.useRangeInterval === true) {
      writer.uint32(16).bool(message.useRangeInterval);
    }
    if (message.rangeInterval !== 0) {
      writer.uint32(29).float(message.rangeInterval);
    }
    if (message.useTimeInterval === true) {
      writer.uint32(32).bool(message.useTimeInterval);
    }
    if (message.timeInterval !== 0) {
      writer.uint32(45).float(message.timeInterval);
    }
    if (message.cameraSettings !== undefined) {
      CameraSettings.encode(message.cameraSettings, writer.uint32(82).fork()).ldelim();
    }
    if (message.photoSettings !== undefined) {
      PhotoSettings.encode(message.photoSettings, writer.uint32(90).fork()).ldelim();
    }
    if (message.photoType !== undefined) {
      PhotoType.encode(message.photoType, writer.uint32(50).fork()).ldelim();
    }
    if (message.photoFormat !== undefined) {
      PhotoFormat.encode(message.photoFormat, writer.uint32(58).fork()).ldelim();
    }
    if (message.photoQuality !== 0) {
      writer.uint32(64).int64(message.photoQuality);
    }
    if (message.exposureMode !== 0) {
      writer.uint32(72).int32(message.exposureMode);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): TogglePhotoIntervalModeActionArgs {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTogglePhotoIntervalModeActionArgs();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.enable = reader.bool();
          continue;
        case 2:
          if (tag !== 16) {
            break;
          }

          message.useRangeInterval = reader.bool();
          continue;
        case 3:
          if (tag !== 29) {
            break;
          }

          message.rangeInterval = reader.float();
          continue;
        case 4:
          if (tag !== 32) {
            break;
          }

          message.useTimeInterval = reader.bool();
          continue;
        case 5:
          if (tag !== 45) {
            break;
          }

          message.timeInterval = reader.float();
          continue;
        case 10:
          if (tag !== 82) {
            break;
          }

          message.cameraSettings = CameraSettings.decode(reader, reader.uint32());
          continue;
        case 11:
          if (tag !== 90) {
            break;
          }

          message.photoSettings = PhotoSettings.decode(reader, reader.uint32());
          continue;
        case 6:
          if (tag !== 50) {
            break;
          }

          message.photoType = PhotoType.decode(reader, reader.uint32());
          continue;
        case 7:
          if (tag !== 58) {
            break;
          }

          message.photoFormat = PhotoFormat.decode(reader, reader.uint32());
          continue;
        case 8:
          if (tag !== 64) {
            break;
          }

          message.photoQuality = longToNumber(reader.int64() as Long);
          continue;
        case 9:
          if (tag !== 72) {
            break;
          }

          message.exposureMode = reader.int32() as any;
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): TogglePhotoIntervalModeActionArgs {
    return {
      enable: isSet(object.enable) ? globalThis.Boolean(object.enable) : false,
      useRangeInterval: isSet(object.useRangeInterval) ? globalThis.Boolean(object.useRangeInterval) : false,
      rangeInterval: isSet(object.rangeInterval) ? globalThis.Number(object.rangeInterval) : 0,
      useTimeInterval: isSet(object.useTimeInterval) ? globalThis.Boolean(object.useTimeInterval) : false,
      timeInterval: isSet(object.timeInterval) ? globalThis.Number(object.timeInterval) : 0,
      cameraSettings: isSet(object.cameraSettings) ? CameraSettings.fromJSON(object.cameraSettings) : undefined,
      photoSettings: isSet(object.photoSettings) ? PhotoSettings.fromJSON(object.photoSettings) : undefined,
      photoType: isSet(object.photoType) ? PhotoType.fromJSON(object.photoType) : undefined,
      photoFormat: isSet(object.photoFormat) ? PhotoFormat.fromJSON(object.photoFormat) : undefined,
      photoQuality: isSet(object.photoQuality) ? globalThis.Number(object.photoQuality) : 0,
      exposureMode: isSet(object.exposureMode) ? exposureMode_EnumFromJSON(object.exposureMode) : 0,
    };
  },

  toJSON(message: TogglePhotoIntervalModeActionArgs): unknown {
    const obj: any = {};
    if (message.enable === true) {
      obj.enable = message.enable;
    }
    if (message.useRangeInterval === true) {
      obj.useRangeInterval = message.useRangeInterval;
    }
    if (message.rangeInterval !== 0) {
      obj.rangeInterval = message.rangeInterval;
    }
    if (message.useTimeInterval === true) {
      obj.useTimeInterval = message.useTimeInterval;
    }
    if (message.timeInterval !== 0) {
      obj.timeInterval = message.timeInterval;
    }
    if (message.cameraSettings !== undefined) {
      obj.cameraSettings = CameraSettings.toJSON(message.cameraSettings);
    }
    if (message.photoSettings !== undefined) {
      obj.photoSettings = PhotoSettings.toJSON(message.photoSettings);
    }
    if (message.photoType !== undefined) {
      obj.photoType = PhotoType.toJSON(message.photoType);
    }
    if (message.photoFormat !== undefined) {
      obj.photoFormat = PhotoFormat.toJSON(message.photoFormat);
    }
    if (message.photoQuality !== 0) {
      obj.photoQuality = Math.round(message.photoQuality);
    }
    if (message.exposureMode !== 0) {
      obj.exposureMode = exposureMode_EnumToJSON(message.exposureMode);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<TogglePhotoIntervalModeActionArgs>, I>>(
    base?: I,
  ): TogglePhotoIntervalModeActionArgs {
    return TogglePhotoIntervalModeActionArgs.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<TogglePhotoIntervalModeActionArgs>, I>>(
    object: I,
  ): TogglePhotoIntervalModeActionArgs {
    const message = createBaseTogglePhotoIntervalModeActionArgs();
    message.enable = object.enable ?? false;
    message.useRangeInterval = object.useRangeInterval ?? false;
    message.rangeInterval = object.rangeInterval ?? 0;
    message.useTimeInterval = object.useTimeInterval ?? false;
    message.timeInterval = object.timeInterval ?? 0;
    message.cameraSettings = (object.cameraSettings !== undefined && object.cameraSettings !== null)
      ? CameraSettings.fromPartial(object.cameraSettings)
      : undefined;
    message.photoSettings = (object.photoSettings !== undefined && object.photoSettings !== null)
      ? PhotoSettings.fromPartial(object.photoSettings)
      : undefined;
    message.photoType = (object.photoType !== undefined && object.photoType !== null)
      ? PhotoType.fromPartial(object.photoType)
      : undefined;
    message.photoFormat = (object.photoFormat !== undefined && object.photoFormat !== null)
      ? PhotoFormat.fromPartial(object.photoFormat)
      : undefined;
    message.photoQuality = object.photoQuality ?? 0;
    message.exposureMode = object.exposureMode ?? 0;
    return message;
  },
};

function createBaseTogglePhotoIntervalModeResultData(): TogglePhotoIntervalModeResultData {
  return {};
}

export const TogglePhotoIntervalModeResultData = {
  encode(_: TogglePhotoIntervalModeResultData, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): TogglePhotoIntervalModeResultData {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTogglePhotoIntervalModeResultData();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): TogglePhotoIntervalModeResultData {
    return {};
  },

  toJSON(_: TogglePhotoIntervalModeResultData): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<TogglePhotoIntervalModeResultData>, I>>(
    base?: I,
  ): TogglePhotoIntervalModeResultData {
    return TogglePhotoIntervalModeResultData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<TogglePhotoIntervalModeResultData>, I>>(
    _: I,
  ): TogglePhotoIntervalModeResultData {
    const message = createBaseTogglePhotoIntervalModeResultData();
    return message;
  },
};

function createBaseTogglePhotoIntervalModeActionStateData(): TogglePhotoIntervalModeActionStateData {
  return {};
}

export const TogglePhotoIntervalModeActionStateData = {
  encode(_: TogglePhotoIntervalModeActionStateData, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): TogglePhotoIntervalModeActionStateData {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTogglePhotoIntervalModeActionStateData();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): TogglePhotoIntervalModeActionStateData {
    return {};
  },

  toJSON(_: TogglePhotoIntervalModeActionStateData): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<TogglePhotoIntervalModeActionStateData>, I>>(
    base?: I,
  ): TogglePhotoIntervalModeActionStateData {
    return TogglePhotoIntervalModeActionStateData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<TogglePhotoIntervalModeActionStateData>, I>>(
    _: I,
  ): TogglePhotoIntervalModeActionStateData {
    const message = createBaseTogglePhotoIntervalModeActionStateData();
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function longToNumber(long: Long): number {
  if (long.gt(globalThis.Number.MAX_SAFE_INTEGER)) {
    throw new globalThis.Error("Value is larger than Number.MAX_SAFE_INTEGER");
  }
  return long.toNumber();
}

if (_m0.util.Long !== Long) {
  _m0.util.Long = Long as any;
  _m0.configure();
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
